import { render, staticRenderFns } from "./PendingSqcs.vue?vue&type=template&id=026a0186&scoped=true&lang=true&"
import script from "./PendingSqcs.vue?vue&type=script&lang=js&"
export * from "./PendingSqcs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026a0186",
  null
  
)

export default component.exports